module.exports = "https://static.energy5.com/_next/static/images/header-c7234d4be9169059c92f9ab570892f1a.png";